module.exports = __webpack_public_path__ + "img/red2.f8d637e5.svg";